import styled from "@emotion/styled";

export const PermissionEditorContentRoot = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 2rem;
  height: 100%;
`;

export const EditorFilterContainer = styled.div`
  margin: 1rem 0 0.5rem 0;
  width: 17.5rem;
`;

export const EditorEmptyStateContainer = styled.div`
  margin-top: 7.5rem;
`;

export const PermissionTableWrapper = styled.div`
  position: relative;
  flex: 1;
  overflow-x: auto;
  padding-bottom: 2rem;
`;
